var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.bars),function(bar,i){return _c('SpacingBar',{key:i,attrs:{"bar":bar,"isDragging":_vm.isDragging,"isActiveBar":_vm.clickedHandle === bar.location},on:{"mousedown":function($event){return _vm.dragStart($event, bar.location)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }